exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js!./_reset.scss"), "");

// module
exports.push([module.id, "html{height:100%;padding:0;margin:0;font-size:100.01%;tab-size:4}body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Miriam Libre,sans-serif;font-size:100%;line-height:1.5;min-width:320px;margin:0;font-weight:700;flex-direction:column}#app,body{min-height:100%;display:flex}#app{flex-direction:column;flex:1 0 auto}main{flex-grow:1}#tfooter,main{flex-shrink:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./_source/stylesheets/_main.scss
// module id = 88
// module chunks = 0